export {
  QualityIndexSwitch,
  IQualityIndexSwitchProps,
  IQualityIndexSwitchValue,
} from "./QualityIndexSwitch";

export {
  EQualityIndex,
}from "./interfaces";
